<div class="wrapper">
  <app-header [disabledMenu]="!canOpenMenu" (hamburgerClick)="drawer.toggle()"></app-header>
  <div style="height: 64px"></div>
  <div class="main">
    <mat-drawer-container autosize>
      <mat-drawer #drawer mode="side" class="main-menu" [opened]="isWideDisplay&&canOpenMenu">
        <app-side-menu (clickMenuItem)="!isWideDisplay&&drawer.close()"></app-side-menu>
      </mat-drawer>
      <mat-drawer-content [ngStyle]="{'height': height + 'px'}">
        <router-outlet></router-outlet>
      </mat-drawer-content>
    </mat-drawer-container>
  </div>
  <app-footer></app-footer>
</div>
